'use client';

import { useState, useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import Button from '@mui/material/Button';
import { unarchiveGroupMutation, groupQuery, myGroupsQuery } from '../../apollo/groups';

type Props = {
  groupId: string;
  slug: string;
};

const UnarchiveGroupButton = ({ groupId, slug }: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const [unarchiveGroup] = useMutation(unarchiveGroupMutation, {
    refetchQueries: [
      { query: groupQuery, variables: { slug } },
      { query: myGroupsQuery },
    ],
  });

  const handleClick = useCallback(() => {
    setSubmitting(true);
    unarchiveGroup({
      variables: { id: groupId },
    }).finally(() => {
      setSubmitting(false);
    });
  }, [groupId, unarchiveGroup]);

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      disabled={submitting}
    >
      {submitting ? 'Unarchiving...' : 'Unarchive Group'}
    </Button>
  );
};

export default UnarchiveGroupButton;
